import { GzTrialProductItemWebComponent } from './component/GzTrialProductItemWebComponent';

export { GzTrialProductItemWebComponent };
